/* Shopify filters availability before pagination. Never trim a paginated grid. */
(() => {
  'use strict';
  if (window.zmBuyableListings) return;
  window.zmBuyableListings = true;
  const pending = new WeakSet();
  const stockURL = (input) => {
    const url = new URL(input, location.origin);
    url.searchParams.set('filter.v.availability', '1');
    if (/\/search\/?$/.test(url.pathname)) {
      url.searchParams.set('options[unavailable_products]', 'hide');
    }
    return url;
  };
  const load = async (placeholder) => {
    if (pending.has(placeholder)) return;
    pending.add(placeholder);
    const sectionId = placeholder.dataset.zmBuyableLoad;
    const url = stockURL(location.href);
    url.searchParams.set('section_id', sectionId);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(`Stock listing HTTP ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const results = html.querySelector('[data-zm-buyable-results]');
      if (!results || results.querySelector('[data-zm-buyable-load]')) {
        throw new Error('Shopify did not apply the availability filter');
      }
      if (!placeholder.isConnected) return;
      placeholder.replaceWith(document.importNode(results, true));
      document.dispatchEvent(new CustomEvent('zm:buyable-ready'));
      // No navigation, history changes, focus or scroll calls on initial load.
    } catch (error) {
      console.error('[Zamoori available products]', error);
      placeholder.replaceChildren();
      const link = document.createElement('a');
      const fallback = stockURL(location.href);
      link.href = fallback.pathname + fallback.search;
      link.textContent = 'View available products';
      placeholder.append(link);
    } finally {
      clearTimeout(timeout);
    }
  };
  const initialize = () => {
    document.querySelectorAll('[data-zm-buyable-load]').forEach(load);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else initialize();
  // Sections can be rendered by native facets or the theme editor.
  new MutationObserver(initialize).observe(document.documentElement, {
    subtree: true, childList: true
  });
})();
